import { Button, Divider, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import customHttp from "../../services/customHTTP";
import Swal from 'sweetalert2';

const ProfileForm = ({ currentUser, setCurrentUser, isEditing, setIsEditing }) => {
    const [profileFormData, setProfileFormData] = useState({
        user_first_name: "",
        user_last_name: "",
        user_email: "",
        user_role: "",
        user_display_name: "",
    });

    const handleProfileInputChange = (e) => {
        const { name, value } = e.target;
        setProfileFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Handle form submit
    const handleProfileFormSubmit = async () => {
        const user_id = currentUser.user_id; // Assuming currentUser has an ID
        const req_body = {
            userId: user_id,
            data: profileFormData,
        };

        try {
            const response = await customHttp.post("/users/update", req_body);
            if (response.status === 200) {
                // Update currentUser values based on profileFormData
                setCurrentUser((prevUser) => {
                    const updatedUser = { ...prevUser, ...profileFormData }; // Merge updated fields
                    // Update sessionStorage with the updated user data
                    sessionStorage.setItem("user", JSON.stringify(updatedUser));
                    
                    return updatedUser;
                });
                setIsEditing(!isEditing);
                Swal.fire({
                    icon: 'success',
                    title: 'Profile Updated',
                    text: 'Your profile has been updated successfully!',
                });
            }
        } catch (error) {
            console.error("Error updating profile:", error);
        }
    };

    useEffect(() => {
        if (currentUser && currentUser.user_first_name) {
            setProfileFormData({
                user_first_name: currentUser.user_first_name || "",
                user_last_name: currentUser.user_last_name || "",
                user_email: currentUser.user_email || "",
                user_role: currentUser.user_role || "",
                user_display_name: currentUser.user_display_name || "",
            });
        }
    }, [currentUser]);
    return (
        <div className="profile-img-form-section">
            <div className="img-section">
                <img src="/user-avatar.jpg" alt="user-img" />
            </div>
            <Divider flexItem orientation="vertical" sx={{ my: 0.5 }} />
            <div className="form-section">
                <div className="form-group">
                    <TextField
                        label="First Name"
                        name="user_first_name"
                        value={profileFormData.user_first_name}
                        fullWidth
                        size="small"
                        disabled={!isEditing}
                        onChange={handleProfileInputChange}
                        className="form-input"
                    />
                    <TextField
                        label="Last Name"
                        name="user_last_name"
                        value={profileFormData.user_last_name}
                        fullWidth
                        size="small"
                        disabled={!isEditing}
                        onChange={handleProfileInputChange}
                        className="form-input"
                    />
                </div>
                <TextField
                    label="Email"
                    name="user_email"
                    value={profileFormData.user_email}
                    fullWidth
                    size="small"
                    disabled={!isEditing}
                    onChange={handleProfileInputChange}
                    className="form-input"
                />
                <TextField
                    label="Role"
                    value={profileFormData.user_role}
                    fullWidth
                    size="small"
                    disabled
                    className="form-input"
                />
                <TextField
                    label="Display Name"
                    name="user_display_name"
                    value={profileFormData.user_display_name}
                    fullWidth
                    size="small"
                    disabled={!isEditing}
                    onChange={handleProfileInputChange}
                    className="form-input"
                />
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!isEditing}
                    className="button-primary"
                    onClick={handleProfileFormSubmit}>
                    Update Profile
                </Button>
            </div>
        </div>
    );
};

export default ProfileForm;
